import { escapeHtml as l } from "../../../../utils/common/index.js";
const p = (t) => m(t).startsWith("bn-"), m = (t) => {
  const e = t.className;
  return typeof e != "string" ? "" : e;
}, f = (t) => t ? t === "right" ? "end" : t : "start";
async function y(t, e = !1) {
  var a;
  try {
    const n = (t == null ? void 0 : t.document) || [];
    if (!n) return "";
    if ((n == null ? void 0 : n.length) === 1) {
      const r = n[0];
      if ((r == null ? void 0 : r.type) === "paragraph" && !((a = r == null ? void 0 : r.content) != null && a.length))
        return console.error("⭐ 沒有內容"), "";
    }
    const o = await (t == null ? void 0 : t.blocksToHTMLLossy((t == null ? void 0 : t.document) || [])), s = new DOMParser().parseFromString(o, "text/html");
    s.body.querySelectorAll("[data-html]").forEach((r) => {
      r.removeAttribute("data-html");
    }), s.body.querySelectorAll("p").forEach((r) => {
      r.innerHTML.trim() === "" && (r.innerHTML = "&nbsp;");
    });
    const c = s.body.innerHTML;
    return e ? l(c) : c;
  } catch (n) {
    return console.error("BlockNote getHtml error:", n), "";
  }
}
export {
  y as getEditorHtml,
  m as getEleClassName,
  p as isLegacy,
  f as toFlexAlign
};
